import { useNavigate } from "react-router-dom";
import classes from "./PageAgentIndividual.module.css";
import { Button, Divider } from "antd";
import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import { FormingAgentInfoForm } from "../../components/AdminAgentInfo/shared/FormingAgentInfoForm/FormingAgentInfoForm";
import { AdminAgentDocuments } from "../../components/AdminAgentInfo/shared/Documents/AdminAgentDocuments";
import { ReferralIndicator } from "../../components/Ui/AdminAgentInfo/ReferralIndicator/ReferralIndicator";
import { AgentIndividualForm } from "../../components/AdminAgentInfo/AgentIndividualForm/AgentIndividualForm";
import { useAppSelector } from "../../store/reduxHooks";
import { useDispatch } from "react-redux";
import { SET_IS_EDIT_AGENT_INDIVIDUAL_INFO_FORM } from "../../store/slice/adminAgentIndividualInfoSlice/AdminAgentIndividualInfoSlice";

export const PageAgentIndividual = () => {
  const navigate = useNavigate();

  const isEdit = useAppSelector(
    (state) => state.adminAgentIndividualInfoSlice.isEdit,
  );

  const dispatch = useDispatch();
  return (
    <>
      <div
        className={`${classes.pageAgent} ${isEdit ? classes.isEdit : ""}`}
      >
        <div className={classes.pageAgentButtonBackWrapper}>
          <Button
            onClick={() => navigate(-1)}
            className={classes.pageAgentButtonBack}
            icon={
              <ArrowLeftOutlined
                className={classes.pageAgentButtonBackIconArrow}
              />
            }
          >
            Назад
          </Button>
        </div>

        <div className={classes.pageAgentHeader}>
          <div className={classes.pageAgentHeaderTitle}>ООО ЭЙТКОМ</div>

          <div className={classes.pageAgentHeaderEditButtonWrapper}>
            <Button
              className={classes.pageAgentHeaderEditButton}
              variant="link"
              color={"primary"}
              iconPosition="end"
              onClick={() => {
                dispatch(SET_IS_EDIT_AGENT_INDIVIDUAL_INFO_FORM(!isEdit));
              }}
              icon={
                <EditOutlined
                  className={classes.pageAgentButtonBackIconArrow}
                />
              }
            ></Button>
          </div>
        </div>

        <ReferralIndicator className={classes.referralIndicator} />

        <AgentIndividualForm />

        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.pageAgentDivider}
          >
            Документы
          </Divider>

          <AdminAgentDocuments />
        </div>

        <div className={classes.pageAgentSectionInfo}>
          <Divider
            orientation="left"
            orientationMargin="0"
            className={classes.pageAgentDivider}
          >
            Сформировать акт
          </Divider>

          <FormingAgentInfoForm
            submitBtnProps={{ children: "Сформировать акт" }}
          />
        </div>

        {isEdit && (
          <div className={classes.editingPanel}>
            <Button
              onClick={() => {
                dispatch(SET_IS_EDIT_AGENT_INDIVIDUAL_INFO_FORM(false));
              }}
              color="red"
              variant="outlined"
            >
              Отмена
            </Button>

            <Button
              className={classes.saveButton}
              color="primary"
              variant="solid"
            >
              Сохранить
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
